

    $(document).ready(function(){

      $('body').on('keyup','.additional_properties .propeties input[type="text"]',function(){    
        if($('.shopify-product-form').find('[name="'+ $(this).attr('name') +'"]').length > 0){
          $('.shopify-product-form').find('[name="'+ $(this).attr('name') +'"]').val($(this).val());
        }else{
         $('.shopify-product-form').append('<input type="hidden" name="'+ $(this).attr('name') +'" class="stitched_properties" value="'+ $(this).val() +'">');     
        }    
        if($(this).val().length == 0){
          $('.shopify-product-form').find('[name="'+ $(this).attr('name') +'"]').remove();
        }
      });


  
    $(".checkbox").click(function() {
      if(this.checked && $('.mul').length > 0 && $("input:checkbox:checked").length > 0) {
           var multNum1= $('.mul').val();
           var multNum = $("input:checkbox:checked").val();
           let number = multNum1 * multNum;
           $('.mul').val(number);
      }else{
          $('.mul').val(1);
      }
    });

    $('.product-info__property:first input').addClass('checkboxnew');
    $(".checkboxnew").click(function() {
      if(this.checked) {  
         $('.mul').val(1);
        // $('.price-list.price-list--lg sale-price.text-lg').text('₹ '+price);
      }
    });
    // $('input:checkbox').click(function(){
    //   var $inputs = $('input:checkbox')
    //   $inputs.not(this).prop('checked', false);
    //   $('.mul').val(1);
    // });  
    var price = $('.price-list.price-list--lg sale-price.text-lg').attr('data-price');  
    $('.product-info__buy-buttons .button--xl.button--secondary').click(function(){    
        var url = window.location.href;      
         $.ajax({
            type: 'GET',
            url: url,
            dataType: 'html',
            success: function(res){
               console.log('res=',res)
               var refresh = $(res).find('.product-info__quantity-selector .quantity-selector').html();
            // $('.product-info__quantity-selector .quantity-selector').html(refresh);
            },
            error: function(status){
                 alert(status);
            }
        })  
    });

    var path = window.location.href; 
     $('.cstmTabs .inner-color-div a').each(function() {
      if (this.href === path) {
       $(this).addClass('active');
      }
     });
      
  });
  
  window.onload = function() {
    $('.cstmhome-tabs').each(function(i){
        $(this).addClass('tabsnew' + i);
    });   
  };
  
// ============================================================

var pInfScrLoading = false;
var pInfScrDelay = 50;
window.__infScrollLoading = false;

function pInfScrExecute() {
  if ($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {

    var pInfScrNode = $('.more').last();
    var pInfScrURL  = $('.more a').last().attr("href");

    // ❌ stop if already loading or no next page
    if (pInfScrLoading || !pInfScrURL) return;

    $.ajax({
      type: 'GET',
      url: pInfScrURL,

      beforeSend: function () {
        pInfScrLoading = true;
        window.__infScrollLoading = true;

        if (!$('.loader-ellips').length) {
          $("#product-list-foot").before(
            '<div class="loader-ellips">' +
              '<span class="loader-ellips__dot"></span>' +
              '<span class="loader-ellips__dot"></span>' +
              '<span class="loader-ellips__dot"></span>' +
              '<span class="loader-ellips__dot"></span>' +
            '</div>'
          );
        }

        pInfScrNode.hide();
      },

      success: function (data) {
  var $data = $(data);

  // 1️⃣ Get new products
  var $newProducts = $data.find('product-list > *');

  // 2️⃣ Get next pagination link
  var $newMore = $data.find('.more').last();

  if ($newProducts.length) {
    // Append products
    $('product-list').append($newProducts);

    // 3️⃣ Replace old ".more" with new one
    if ($newMore.length) {
      $('.more').replaceWith($newMore);
      pInfScrLoading = false;
      window.__infScrollLoading = false;
      $('.loader-ellips').remove();
    } else {
      // ❌ No next page
      $('.loader-ellips').remove();
      $('.more').remove();
      $(window).off('scroll');
    }

  } else {
    // ❌ No products returned
    $('.loader-ellips').remove();
    $('.more').remove();
    $(window).off('scroll');
  }
},

      error: function () {
        $('.loader-ellips').remove();
        pInfScrLoading = false;
        window.__infScrollLoading = false;
      },

      dataType: "html"
    });
  }
}


$(document).ready(function () {
  $(window).scroll(function(){
    $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
    if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      pInfScrDelay = 50;
    }
  });
  if (window.location.href.indexOf("/products/") > -1) {
    let el= document.querySelector('.shopify-section--main-product .product-info__buy-buttons');
    let element = document.querySelector('.shopify-section--main-product .product-quick-add');
    // if(isInViewport(el)) {
    //   element.classList.remove("is-visible");
    // }
    // $(window).scroll(function(){
    //   if(isInViewport(el)) {
    //     element.classList.remove("is-visible");
    //   }
    // });
      function isInViewport(el) {
          const rect = el.getBoundingClientRect();
          return (
              rect.top >= 0 &&
              rect.left >= 0 &&
              rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          
          );
        }
    }
});



//     $(document).ready(function(){

//       $('body').on('keyup','.additional_properties .propeties input[type="text"]',function(){    
//         if($('.shopify-product-form').find('[name="'+ $(this).attr('name') +'"]').length > 0){
//           $('.shopify-product-form').find('[name="'+ $(this).attr('name') +'"]').val($(this).val());
//         }else{
//          $('.shopify-product-form').append('<input type="hidden" name="'+ $(this).attr('name') +'" class="stitched_properties" value="'+ $(this).val() +'">');     
//         }    
//         if($(this).val().length == 0){
//           $('.shopify-product-form').find('[name="'+ $(this).attr('name') +'"]').remove();
//         }
//       });


  
//     $(".checkbox").click(function() {
//       if(this.checked && $('.mul').length > 0 && $("input:checkbox:checked").length > 0) {
//            var multNum1= $('.mul').val();
//            var multNum = $("input:checkbox:checked").val();
//            let number = multNum1 * multNum;
//            $('.mul').val(number);
//       }else{
//           $('.mul').val(1);
//       }
//     });

//     $('.product-info__property:first input').addClass('checkboxnew');
//     $(".checkboxnew").click(function() {
//       if(this.checked) {  
//          $('.mul').val(1);
//         // $('.price-list.price-list--lg sale-price.text-lg').text('₹ '+price);
//       }
//     });
//     $('input:checkbox').click(function(){
//       var $inputs = $('input:checkbox')
//       $inputs.not(this).prop('checked', false);
//       $('.mul').val(1);
//     });  
//     var price = $('.price-list.price-list--lg sale-price.text-lg').attr('data-price');  
//     $('.product-info__buy-buttons .button--xl.button--secondary').click(function(){    
//         var url = window.location.href;      
//          $.ajax({
//             type: 'GET',
//             url: url,
//             dataType: 'html',
//             success: function(res){
//                console.log('res=',res)
//                var refresh = $(res).find('.product-info__quantity-selector .quantity-selector').html();
//             // $('.product-info__quantity-selector .quantity-selector').html(refresh);
//             },
//             error: function(status){
//                  alert(status);
//             }
//         })  
//     });

//     var path = window.location.href; 
//      $('.cstmTabs .inner-color-div a').each(function() {
//       if (this.href === path) {
//        $(this).addClass('active');
//       }
//      });
      
//   });
  
//   window.onload = function() {
//     $('.cstmhome-tabs').each(function(i){
//         $(this).addClass('tabsnew' + i);
//     });   
//   };
  
// // ============================================================

// // var pInfScrLoading = false;
// // var pInfScrDelay = 50;

// // function pInfScrExecute() {
// //   if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
// //     $('.loader-ellips').remove();
// //     $("#product-list-foot").before('<div class="loader-ellips"><span class="loader-ellips__dot"></span><span class="loader-ellips__dot"></span><span class="loader-ellips__dot"></span><span class="loader-ellips__dot"></span></div>')
// //     var loadingImage;
// //     var pInfScrNode = $('.more').last();	
// //     var pInfScrURL = $('.more a').last().attr("href");
// //     if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {      
// //       $.ajax({
// //         type: 'GET',
// //         url: pInfScrURL,
// //         beforeSend: function() {
// //           pInfScrLoading = true;
// //           loadingImage = pInfScrNode.clone().empty().append('');
// //           loadingImage.insertAfter(pInfScrNode);
// //           pInfScrNode.hide();
// //         },
// //         success: function(data) {
// //           // remove loading feedback
// //           pInfScrNode.next().remove();
// //           $('.loader-ellips').remove();
// //           var filteredData = $(data).find("product-list");
// //           filteredData.insertBefore( $("#product-list-foot") );
// //           loadingImage.remove();					
// //           pInfScrLoading = false;
// //         },
// //         dataType: "html"
// //       });
// //     }
// //   }
// // }
// var pInfScrLoading = false;
// var pInfScrDelay = 50;
// window.__infScrollLoading = false;

// function pInfScrExecute() {
//   if ($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {

//     var pInfScrNode = $('.more').last();
//     var pInfScrURL  = $('.more a').last().attr("href");

//     // ❌ stop if already loading or no next page
//     if (pInfScrLoading || !pInfScrURL) return;

//     $.ajax({
//       type: 'GET',
//       url: pInfScrURL,

//       beforeSend: function () {
//         pInfScrLoading = true;
//         window.__infScrollLoading = true;

//         if (!$('.loader-ellips').length) {
//           $("#product-list-foot").before(
//             '<div class="loader-ellips">' +
//               '<span class="loader-ellips__dot"></span>' +
//               '<span class="loader-ellips__dot"></span>' +
//               '<span class="loader-ellips__dot"></span>' +
//               '<span class="loader-ellips__dot"></span>' +
//             '</div>'
//           );
//         }

//         pInfScrNode.hide();
//       },

//       success: function (data) {
//   var $data = $(data);

//   // 1️⃣ Get new products
//   var $newProducts = $data.find('product-list > *');

//   // 2️⃣ Get next pagination link
//   var $newMore = $data.find('.more').last();

//   if ($newProducts.length) {
//     // Append products
//     $('product-list').append($newProducts);

//     // 3️⃣ Replace old ".more" with new one
//     if ($newMore.length) {
//       $('.more').replaceWith($newMore);
//       pInfScrLoading = false;
//       window.__infScrollLoading = false;
//       $('.loader-ellips').remove();
//     } else {
//       // ❌ No next page
//       $('.loader-ellips').remove();
//       $('.more').remove();
//       $(window).off('scroll');
//     }

//   } else {
//     // ❌ No products returned
//     $('.loader-ellips').remove();
//     $('.more').remove();
//     $(window).off('scroll');
//   }
// },

//       error: function () {
//         $('.loader-ellips').remove();
//         pInfScrLoading = false;
//         window.__infScrollLoading = false;
//       },

//       dataType: "html"
//     });
//   }
// }
// $(document).ready(function () {
//   $(window).scroll(function(){
//     $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
//     if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
//       pInfScrDelay = 50;
//     }
//   });
//   if (window.location.href.indexOf("/products/") > -1) {
//     let el= document.querySelector('.shopify-section--main-product .product-info__buy-buttons');
//     let element = document.querySelector('.shopify-section--main-product .product-quick-add');
//     // if(isInViewport(el)) {
//     //   element.classList.remove("is-visible");
//     // }
//     // $(window).scroll(function(){
//     //   if(isInViewport(el)) {
//     //     element.classList.remove("is-visible");
//     //   }
//     // });
//       function isInViewport(el) {
//           const rect = el.getBoundingClientRect();
//           return (
//               rect.top >= 0 &&
//               rect.left >= 0 &&
//               rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
//               rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          
//           );
//         }
//     }
// });
